<div class="snackbar-container">
  <img src="/assets/icons/warning-icon.svg" alt="tick" />
  <p class="content-text">
    {{ data.message }}
  </p>
</div>
